/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

// TODO: rename this model to be more intuative
module.exports = Model({
	name: "braceletowner",
	init: init,
	uninit: uninit,
	listeners: listeners,

	getOwnerUser: getOwnerUser,

	_machines: null
});

function init() {
	this._machines = {};
	this.push(false);
}

function uninit() {
	this._machines = null;
}

function listeners() {
	return {
		"groupmachines:updated": handle_goup_machines_updated,
		"machineevents:taken": handle_taken,
		"ownbraceletevents:disconnected": handle_disconnected,
		"availability:updated": handle_availability_update,
	};
}

function handle_taken(data) {
	var owner = data.from;
	this.push(owner);
	var ownerUser = this.getOwnerUser();
	if (!ownerUser) return;
	this.emit("availability:trigger:add", {
		who: [ownerUser]
	});
}

function handle_disconnected() {
	if (this.data) this.push(false);
}

function handle_availability_update(available) {
	var ownerUser = this.getOwnerUser();
	if (!ownerUser) return;
	if (available[ownerUser]) return;

	this.emit("ownbraceletevents:trigger:disconnected", {
		reason: "offline"
	});

	this.push(false);

	this.dispatch("disconnected");
}

function handle_goup_machines_updated(machines) {
	this._machines = machines;
}

function getOwnerUser() {
	var owner = this.data;
	if (!owner) return;
	var ownerDevice = this._machines[owner];
	if (!ownerDevice) return;
	return ownerDevice.who;
}
